import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';

export const VarmefordelingRadio = () => {
  const { register, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });

  const error = formState.errors?.varmepumpe?.value?.varmefordeling?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('varmepumpe.varmefordeling.label')}</Fieldset.Legend>
      <Radio
        {...register('varmepumpe.value.varmefordeling', {
          required: t('varmepumpe.varmefordeling.error'),
          shouldUnregister: true
        })}
        aria-invalid={!!error}
        label={t('varmepumpe.varmefordeling.options.punktoppvarming')}
        value="punktoppvarming"
      />
      <Radio
        aria-invalid={!!error}
        {...register('varmepumpe.value.varmefordeling', {
          required: t('varmepumpe.varmefordeling.error'),
          shouldUnregister: true
        })}
        label={t('varmepumpe.varmefordeling.options.vannbarenVarme')}
        value="vannbarenVarme"
      />
      {error && <ValidationMessage>{error}</ValidationMessage>}
    </Fieldset>
  );
};
